import axios from "./axios";
import router from "../../router/router"
//import { $cookies } from "vue/types/umd";
//import VueRouter from "vue-router";
import cookies from "./cookies"

//Vue.use(VueCookies)

export default {
  namespaced: true,

  state: {
    token: localStorage.getItem("access_token") || null,
    loggedIn: localStorage.getItem("login") || false,
    profiles: [],
  },
  getters: {
    gLoggedIn(state) {
      return state.loggedIn;
    },
    gToken() {
      return localStorage.getItem("access_token")
    }
  },
  actions: {
    aValidateToken(commit, token) {
      return new Promise((resolve, reject) => {
        axios.post('check_token', JSON.stringify(token))
        .then(response => {
          if (response.data.status) {
            resolve(1)
          } else {
            resolve(0)
          }
        })
        .catch(error => {
          reject(error)
        })
      })
    },

    aRegisterUser({ commit }, user) {
      return new Promise((resolve, reject) => {
        axios.post('register', JSON.stringify(user))
          .then(response => {
            if (response.data.status) {
              resolve(1)
              commit('mMessage', response.data.message, {root: true});
            } else {
              commit('mMessage', response.data.data, { root: true });
              //context.commit('NewMessage', response.data.message)
              //context.commit('NewMessages', response.data.data)
              resolve(0)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    aLoginUser({ commit }, user) {
      return new Promise((resolve, reject) => {
        axios.post('login', JSON.stringify(user))
          .then(response => {
            if (response.data.status) {
              //commit('mMessage', response.data.message, {root: true});
              commit('mSetToken', response.data.token);
              //add the name
              if (response.data.data.account_name == null) {
                commit('user/mSetAccountName', response.data.data.email, {root: true});
              } else {
                commit('user/mSetAccountName', response.data.data.account_name, {root: true});
              }
              resolve(1)
            } else {
              commit('mMessage', response.data.message, {root: true});
              resolve(0);
            }
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    aLogout() {
      return new Promise((resolve) => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('usr-subs-ion')
        localStorage.removeItem('account_name')
        localStorage.removeItem('current_profile')
        localStorage.removeItem('current_subscription')
        resolve(1)
      })
    },
    aValidToken({ state, dispatch }){
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.token
        axios.get("validatetoken")
        .then(response => {
          if (response.data.status) {
            resolve(1)
          }
        })
        .catch(error => {
          if (error.response.data.message == "Unauthenticated.") {
            dispatch("aDestroyToken")
          }
          reject(0)
        })
      })
    },
    aAuthenticated({dispatch}, message) {
      //if the user is not authenticated, redirect to login
      if (message == "Unauthenticated") {
        //commit()
        dispatch("aDestroyToken");
        router.push({name: "Logout"});
      }
    },
    aDestroyToken({ commit, getters, state, rootState }) {
      if (getters.gLoggedIn) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.token
          axios.post("logout")
            .then(response => {
              if (response.data.status) {
                rootState.user.profileName = "";
                rootState.user.currentProfileSub = 0;
                commit('mSetDestroyToken');
                resolve(true);
              } else if (response.data.message == "Unauthenticated" || response.data.status == 0) {
                rootState.user.profileName = "";
                commit('mSetDestroyToken');
                resolve(true);
              }
            })
            .catch(error => {
              commit('mSetDestroyToken');
              reject(error.response)
            })
        })
      } else {
        commit('mSetDestroyToken');
        console.log("I am not sure what is happening now");
      }
    },
    aTokenLogin({ commit }, token) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = "Bearer " + token
        axios.get("tokenlogin")
        .then(response => {
          if (response.data.status) {
            commit("mSetToken", token)
            commit('user/mSetAccountName', response.data.data.email, {root: true});
            console.log("redirecting to profiles")
            router.push({name: "Profiles"})
            location.reload();
            resolve(1)
          }
        })
        .catch(error => {
          console.log(error.response)
          reject(0)
        })
        
      })
    },
    aForgotPassword({ commit }, envelop) {
      return new Promise((resolve, reject) => {
        const parcel = JSON.stringify(envelop)
        axios.post('forgot/password', parcel)
          .then(response => {
            if (response.data.status) {
              commit('mMessage', response.data.message, {root: true})
            } else {
              commit('mMessage', response.data.message, {root: true})
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    aResetPassword({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.post('password/reset', JSON.stringify(value))
          .then(response => {
            if (response.data.status) {
              commit('mMessage', response.data.message, {root: true})
              resolve(1)
            } else {
              commit('mMessage', response.data.message, {root: true})
              resolve(0)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    aCheckResetToken({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.post('password/reset/token', JSON.stringify(value))
          .then(response => {
            if (response.data.status) {
              resolve(1)
            } else {
              commit('mMessage', response.data.message, {root: true})
              resolve(0)
            }
          },
          )
          .catch(error => {
            reject(error)
          })
      })
    },
  },
  mutations: {
    mSetToken(state, token) {
      //console.log("storing token", token)
      //$cookies.set("people", "other places")
      cookies.set("token", token, "1d", null, "mi-sos.org", null, "Secure")
      //document.cookie = "token="+ token + ";domain=mi-sos.org"
      localStorage.setItem('access_token', token)
      localStorage.setItem('login', true)
      state.loggedIn = true
      state.token = token
      //on login, clear the profiles
      localStorage.setItem('current_profile', 0)
      //state.currentProfile = null
      localStorage.setItem('current_subscription', 0)
    },
    mSetDestroyToken(state) {
      state.loggedIn = false;
      state.token = null;

      //state.accountName = null;
      localStorage.removeItem('access_token');
      localStorage.removeItem('current_profile');
      localStorage.removeItem('username');
      localStorage.removeItem('account_name');
      localStorage.removeItem('current_subscription');
      localStorage.removeItem('login');
      localStorage.removeItem('profile_name');
      cookies.remove("token", null, "mi-sos.org")
      //router.push({name: "Login"});
    },
  }
}